import React from 'react'
import moment from 'moment'

export const globalStudentTaskColumns = (layout, role, studentId, type, isStudent, handleCheckboxStudentTask, handleDelete, handleEdit, handleDismissedChange) =>
	[
		{
			id: 'taskname',
			name: 'Task',
			selector: (row) => row.taskname,
			sortable: true,
			minWidth: '400px',
			wrap: true
		},
		{
			name: 'Assigned',
			selector: (row) => moment(row.taskdate).format('MMM DD'),
			sortable: true,
			width: '120px',
			minWidth: '120px',
			maxWidth: '120px',
			center: true
		},
		{
			name: 'Due',
			selector: (row) => moment(row.taskenddate).format('MMM DD'),
			sortable: true,
			width: '120px',
			minWidth: '120px',
			maxWidth: '120px',
			center: true
		},
		{
			name: 'Complete',
			cell: (row) => <input type="checkbox" checked={row.isFinish} onChange={() => handleCheckboxStudentTask(row.id, row.isFinish)} />,
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
			width: '110px',
			minWidth: '110px',
			maxWidth: '110px',
			center: true
		},
		{
			name: 'Dismissed',
			cell: (row) => <input type="checkbox" checked={row.ishide} onChange={() => handleDismissedChange(row.id, row.ishide)} />,
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
			width: '110px',
			minWidth: '110px',
			maxWidth: '110px',
			center: true
		},
		!isStudent && {
			name: 'Actions',
			cell: (row) => (
				<div className="d-flex justify-content-center gap-2">
					<button
						onClick={() => handleEdit(row)}
						className="btn btn-success btn-sm"
						style={{ minWidth: '40px', padding: '6px 12px' }}
					>
						<i className="fa fa-edit me-1"></i>
					</button>
					<button className="btn btn-danger btn-sm" style={{ minWidth: '40px', padding: '6px 12px' }} onClick={() => handleDelete(row.id)}>
						 <i className="fa fa-trash"></i>
					</button>
				</div>
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
			width: '150px',
			minWidth: '150px',
			maxWidth: '150px',
			right: true
		}
	].filter(Boolean)
